import {DataAttribute} from '@app/views/admin/application-settings/models/data-attribute.model';

export const DENIED_FILTER_ATTRIBUTES = [
    'otherEmails',
    'sisIds',
    'otherIds',
    'metadata',
    'otherPhoneNumbers',
    'groupMemberships',
    'otherEnrollments',
    'relationships',
    'otherAssignments',
    'otherStaffs',
    'members',
    'otherPhoneNumbers[fax]',
    'otherPhoneNumbers[home]',
    'otherPhoneNumbers[mobile]',
    'otherPhoneNumbers[other]',
    'otherPhoneNumbers[text]',
    'otherPhoneNumbers[work]',
    'districtId'
];

export function getAllowedAttributes(type: string, attributes: DataAttribute[]): DataAttribute[] {
    return attributes.filter((attr: DataAttribute) =>
        DENIED_FILTER_ATTRIBUTES.indexOf(attr.propertyName) === -1
        && !attr.isDeniedNotAllowedForFilterRules
    );
}

/**
 * Deprecated
 */
export const ALLOWED_FILTERED_ATTRIBUTES = {
    'Calendar' : [
        'sisIds[canv_id]',
        'sisIds[ed_fi_id]',
        'sisIds[google_classroom_id]',
        'sisIds[google_id]',
        'sisIds[ldap_id]',
        'sisIds[mb_id]',
        'sisIds[ms_sds_id]',
        'sisIds[oa_id]',
        'sisIds[or_id]',
        'sisIds[ps_id]',
        'sisIds[sw_id]',
        'sisIds[xpr_id]',
        'sessions.description',
        'sessions.startDate',
        'sessions.endDate',
        'schoolYear'
    ],
    'Contact' : [
        'sisIds[canv_id]',
        'sisIds[ed_fi_id]',
        'sisIds[google_classroom_id]',
        'sisIds[google_id]',
        'sisIds[ldap_id]',
        'sisIds[mb_id]',
        'sisIds[ms_sds_id]',
        'sisIds[oa_id]',
        'sisIds[or_id]',
        'sisIds[ps_id]',
        'sisIds[sw_id]',
        'sisIds[xpr_id]',
        'name.familyName',
        'name.givenName',
        'email.emailAddress',
        'personStatus'
    ],
    'Course': [
        'sisIds[canv_id]',
        'sisIds[ed_fi_id]',
        'sisIds[google_classroom_id]',
        'sisIds[google_id]',
        'sisIds[ldap_id]',
        'sisIds[mb_id]',
        'sisIds[ms_sds_id]',
        'sisIds[oa_id]',
        'sisIds[or_id]',
        'sisIds[ps_id]',
        'sisIds[sw_id]',
        'sisIds[xpr_id]',
        'courseDistrictId',
        'courseSchoolId',
        'courseTitle',
        'grades',
        'scedCode',
        'scedLevel',
        'scedSubject',
        'subject'
    ],
    'Group' : [
        'sisIds[canv_id]',
        'sisIds[ed_fi_id]',
        'sisIds[google_classroom_id]',
        'sisIds[google_id]',
        'sisIds[ldap_id]',
        'sisIds[mb_id]',
        'sisIds[ms_sds_id]',
        'sisIds[oa_id]',
        'sisIds[or_id]',
        'sisIds[ps_id]',
        'sisIds[sw_id]',
        'sisIds[xpr_id]',
        'name'
    ],
    'Roster': [
        'sisIds[canv_id]',
        'sisIds[ed_fi_id]',
        'sisIds[google_classroom_id]',
        'sisIds[google_id]',
        'sisIds[ldap_id]',
        'sisIds[mb_id]',
        'sisIds[ms_sds_id]',
        'sisIds[oa_id]',
        'sisIds[or_id]',
        'sisIds[ps_id]',
        'sisIds[sw_id]',
        'sisIds[xpr_id]',
        'grades',
        'schoolYear',
        'sectionAlias',
        'sectionName',
        'subject'
    ],
    'RosterStudentEnrollment': [],
    'School': [
        'highGrade',
        'lowGrade',
        'schoolName'
    ],
    'SchoolAdmin': [
        'sisIds[canv_id]',
        'sisIds[ed_fi_id]',
        'sisIds[google_classroom_id]',
        'sisIds[google_id]',
        'sisIds[ldap_id]',
        'sisIds[mb_id]',
        'sisIds[ms_sds_id]',
        'sisIds[oa_id]',
        'sisIds[or_id]',
        'sisIds[ps_id]',
        'sisIds[sw_id]',
        'sisIds[xpr_id]',
        'name.familyName',
        'name.givenName',
        'email.emailAddress',
        'personStatus',
        'staffNumber'
    ],
    'Staff': [
        'sisIds[canv_id]',
        'sisIds[ed_fi_id]',
        'sisIds[google_classroom_id]',
        'sisIds[google_id]',
        'sisIds[ldap_id]',
        'sisIds[mb_id]',
        'sisIds[ms_sds_id]',
        'sisIds[oa_id]',
        'sisIds[or_id]',
        'sisIds[ps_id]',
        'sisIds[sw_id]',
        'sisIds[xpr_id]',
        'name.familyName',
        'name.givenName',
        'email.emailAddress',
        'personStatus',
        'staffNumber'
    ],
    'Student' : [
        'sisIds[canv_id]',
        'sisIds[ed_fi_id]',
        'sisIds[google_classroom_id]',
        'sisIds[google_id]',
        'sisIds[ldap_id]',
        'sisIds[mb_id]',
        'sisIds[ms_sds_id]',
        'sisIds[oa_id]',
        'sisIds[or_id]',
        'sisIds[ps_id]',
        'sisIds[sw_id]',
        'sisIds[xpr_id]',
        'name.familyName',
        'name.givenName',
        'email.emailAddress',
        'demographics.birthDate',
        'personStatus',
        'studentNumber',
        'studentEnrollment.grade'
    ]
};

/**
 * Deprecated
 */
// export function getAllowedAttributes(type: string, attributes: DataAttribute[]): DataAttribute[] {
//     return attributes.filter((attr: DataAttribute) =>
//         ALLOWED_FILTERED_ATTRIBUTES[type].indexOf(attr.propertyName) > -1);
// }
